<template>
<b-modal v-model="showFlg"
         size="lg"
         header-bg-variant="light"
         :modal-class="'setHeight081'"
         :title="$t('sh063.labels.changeHopeDateAndTime')"
         :hide-footer="true"
         @hide ="handleCancel"
         no-close-on-backdrop>
    <div class="sh063" v-cloak>
        <div class="pageFeed">
            <div class="section-inner">
                <loading :active.sync="isLoading" 
                :can-cancel="false"
                :background-color="'transparent'">
                </loading>
                <!--エラーメッセージ表示 -->
                <div class="errMessage">
                    <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH063_PART"/>
                </div>
                <br>
                <!-- 店頭受取以外の場合 90:店頭受取 -->
                <h3 v-if="sh063TdkReqModel.binsyuKbn != '90' && (sh063Init.tdkKibouFlg==1 || sh063Init.tdkTimeFlg == 1)" class="subTitle" style="display:block;">{{$t('sh063.labels.deliDates')}}</h3>
                <br v-if="sh063TdkReqModel.binsyuKbn != '90' && (sh063Init.tdkKibouFlg==1 || sh063Init.tdkTimeFlg == 1)">
                <!-- 店頭受取の場合 90:店頭受取 -->
                <h3 v-if="sh063TdkReqModel.binsyuKbn == '90'" class="subTitle" style="display:block;">{{$t('sh063.labels.pickupDate')}}</h3>
                <br v-if="sh063TdkReqModel.binsyuKbn == '90'">
                <div>
                    <!--page table -->
                    <table class="table" id="cart-tdkYmd">
                        <tbody>
                            <!-- 店頭受取以外の場合 90:店頭受取 -->
                            <!-- ECサイトオプション配送指定日利用オプション 50504、利用しない場合、お届け希望日時の枠自体を非表示にする -->
                            <tr class="tableTr" v-if="sh063TdkReqModel.binsyuKbn != '90' && sh063Init.tdkKibouFlg==1">
                                <!-- 希望日 -->
                                <th :class="sh063TdkReqModel.tdkYmdHissuFlg == 1?'text-danger':''" style="width:130px;">{{$t("sh063.labels.hopeDates")}}</th>
                                <td bgcolor="#FFFFFF" height="120" class="td-res-height">
                                    <div class="div_unspecified" style="display:flex;align-items:center;">
                                        <!-- 指定なし -->
                                        <input class="sh063-inp-radioGroup1" id="radioGroup1" type="radio" name="radioGroup1" :value="1" 
                                            :disabled="sh063ItemControl.radioGrp1Flg != 1" v-model="sh063TdkReqModel.radioGroup1" @click="hopeDayRadio(1)"/>
                                        <label style="margin-bottom:0px;" class="sh063-lbl-radioGroup1" for="radioGroup1">：{{$t("sh063.labels.unspecified")}}</label><br><br>
                                    </div>
                                    <div class="div_hopeDay" style="display:flex;align-items:center;">
                                        <!--お届希望日-->
                                        <input class="sh063-inp-radioGroup2" id="radioGroup2" type="radio" name="radioGroup1" :value="2" 
                                            :disabled="sh063ItemControl.radioGrp2Flg != 1" v-model="sh063TdkReqModel.radioGroup1" @click="hopeDayRadio(2)"/>
                                        <label style="margin-bottom:0px;" class="sh063-lbl-radioGroup2" for="radioGroup2">：{{$t("sh063.labels.deliDateSetting")}}</label>
                                        <select name="hopeDay" id="hopeDay" class="hopeDay" :disabled="sh063ItemControl.ymdHopeFlg != 1 || sh063TdkReqModel.radioGroup1 != 2" 
                                            v-model="sh063TdkReqModel.hopeTdkYmd" style="width:240px;">
                                                <option v-for="day in sh063Init.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.VALUE}}</option>
                                        </select><br><br>
                                    </div>
                                    <!--のみ、以降オプション-->
                                    <div v-if="sh063Init.chakubiOption == 1" class="div_afterDay" style="display:flex;align-items:center;">
                                        <!--以降にお届け-->
                                        <input class="sh063-inp-radioGroup2" id="radioGroup3" type="radio" name="radioGroup1" :value="3" 
                                            :disabled="sh063ItemControl.radioGrp3Flg != 1" v-model="sh063TdkReqModel.radioGroup1" @click="hopeDayRadio(3)"/>
                                        <label style="margin-bottom:0px;" class="sh063-lbl-radioGroup3">：</label>
                                        <select name="afterDay" id="afterDay" class="hopeDay" :disabled="sh063ItemControl.ymdAftFlg != 1 || sh063TdkReqModel.radioGroup1 != 3" 
                                            v-model="sh063TdkReqModel.hopeTdkYmdAfter" style="width:240px;">
                                                <option v-for="day in sh063Init.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.KEY}}</option>
                                        </select>
                                        <label style="margin-bottom:0px;" class="sh063-lbl-radioGroup2" for="radioGroup3">{{$t("sh063.labels.deliAfterDate")}}</label>
                                    </div>
                                </td>
                            </tr>
                            <!-- ECサイトオプション50505（非表示）の場合は、お届け希望日時の枠自体を非表示にする -->
                            <!-- 店頭受取以外の場合 90:店頭受取 -->
                            <tr class="tableTr" v-if="sh063Init.tdkTimeFlg == 1 && sh063TdkReqModel.binsyuKbn != '90'">
                                <!-- 希望時間 -->
                                <th :class="sh063TdkReqModel.tdkHstmHissuFlg == 1?'text-danger':''" style="width:130px;">{{$t("sh063.labels.deliTime")}}</th>
                                <td bgcolor="#FFFFFF" height="60" class="td-res-height">
                                    <!--お届希望時間帯-->
                                    <select name="hopeTime" id="hopeTime" class="hopeTime" :disabled="sh063ItemControl.timeHopeFlg != 1" 
                                        v-model="sh063TdkReqModel.hopeTdkTimeKbn" style="width:240px;">
                                        <option v-for="time in sh063Init.hopeTimeList" :value="time.KEY" :key="time.KEY" >{{time.VALUE}}</option>
                                    </select>  
                                </td>
                            </tr>
                            <!-- 店頭受取の場合 90:店頭受取 -->
                            <tr class="tableTr" v-if="sh063TdkReqModel.binsyuKbn == '90'">
                                <!-- 希望日 -->
                                <th :class="sh063TdkReqModel.tdkYmdHissuFlg == 1?'text-danger':''" style="width:130px;vertical-align:middle;">{{$t("sh063.labels.pickupDateTh")}}</th>
                                <td bgcolor="#FFFFFF" height="60" class="td-res-height">
                                    <div class="div_hopeDay" style="display:flex;align-items:center;">
                                        <!--受取日-->
                                        <input class="sh063-inp-radioGroup2" id="radioGroup2" type="radio" name="radioGroup1" :value="2" 
                                            :disabled="sh063ItemControl.radioGrp2Flg != 1" v-model="sh063TdkReqModel.radioGroup1" @click="hopeDayRadio(4)"/>
                                        <label style="margin-bottom:0px;" class="sh063-lbl-radioGroup2" for="radioGroup2">：{{$t("sh063.labels.pickupDateSetting")}}</label>
                                        <select name="pickupYmd" id="pickupYmd" class="pickupYmd" :disabled="sh063ItemControl.pickupYmdFlg != 1 || sh063TdkReqModel.radioGroup1 != 2" 
                                            v-model="sh063TdkReqModel.pickupYmd" style="width:240px;">
                                                <option v-for="day in sh063Init.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.VALUE}}</option>
                                        </select><br><br>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- giftFlg:ギフトオプション（50512） -->
                <!-- noshiUseFlg:のし利用オプション（50506） -->
                <!-- housouFukaFlg:包装可フラグ、包装可の商品がない場合、0になる。1:包装可 0:包装不可-->
                <!-- noshiOkFlg:1:のし使用可商品あり-->
                <div v-if="(sh063Init.giftFlg == 1 || sh063Init.noshiUseFlg == 1) && (sh063Init.housouFukaFlg == 1 || sh063TdkReqModel.noshiOkFlg == 1)">
                    <h3 class="subTitle" style="display:block;">{{$t('sh063.labels.giftSetting')}}</h3><br>
                    <!--page table -->
                    <table class="table" id="cart-tdkGift">
                        <tbody>
                            <!-- 包装可、ギフトオプション（50512）を使用する -->
                            <tr class="tableTr" v-if="sh063Init.housouFukaFlg == 1 && sh063Init.giftFlg == 1">
                                <!-- ギフト設定 -->
                                <th class="giftCd" style="width:130px;">{{$t("sh063.labels.giftSettingTh")}}</th>
                                <td colspan="2" bgcolor="#FFFFFF" height="60" class="td-res-height">
                                    <div class="giftCd" style="display:flex;align-items:center;">
                                        <select class="giftCdSelect" 
                                            data-live-search="true"
                                            id="giftCd"
                                            style="width:120px;"
                                            v-model="sh063TdkReqModel.giftCd"
                                            >
                                            <option v-for="gift in sh063Init.giftList" :key="gift.KEY" :value="gift.KEY">{{gift.VALUE}}</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <!-- のし・包装 -->
                            <!-- 包装可、noshiUseFlg:のし利用オプション50506を使用する、giftMode:ギフトモード -->
                            <tr class="tableTr" v-if="sh063Init.housouFukaFlg == 1 && sh063Init.noshiUseFlg == 1 && sh063TdkReqModel.giftMode =='1'">
                                <!-- 包装 -->
                                <th rowspan="7" class="housouTh">{{$t("sh063.labels.housouTh")}}</th>
                                <td bgcolor="#FFFFFF" height="60" class="td-res-height">
                                    <div class="housouKbnDiv" style="display:flex;align-items:center;">
                                        <label style="margin-bottom:0px;" class="sh063-lbl-housouKbn text-danger" for="housouKbn">{{$t("sh063.labels.housouCd")}}</label>
                                        <select class="housouKbnSelect" 
                                            data-live-search="true"
                                            id="housouKbn"
                                            v-model="sh063TdkReqModel.housouKbn"
                                            v-on:change="housouKbnChange"
                                            :disabled="sh063Init.onlyEcoFlg == 0"
                                            style="width:220px;"
                                            >
                                            <option v-for="item in sh063Init.housouKbnList" 
                                                :key="item.SAGYO_CD" :value="item.SAGYO_CD">{{item.SAGYO_NM}}
                                            </option>
                                        </select>
                                    </div>
                                </td>
                                <!-- のし -->
                                <td bgcolor="#FFFFFF" height="60" class="td-res-height">
                                    <div class="noshiCdDiv" style="display:flex;align-items:center;">
                                        <label id="noshiCd_lbl" style="margin-bottom:0px;" class="sh063-lbl-noshiCd" for="noshiCd">{{$t("sh063.labels.noshiCd")}}</label>
                                        <!-- エコ包装 -->
                                        <select v-if="sh063TdkReqModel.ecoHousouMode == '1'" 
                                            class="noshiCdSelect" 
                                            data-live-search="true"
                                            id="noshiCd"
                                            v-model="sh063TdkReqModel.noshiCd"
                                            style="width:220px;"
                                            :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                            >
                                            <option v-for="item in sh063Init.noshiCdList" 
                                                :key="item.SAGYO_CD" :value="item.SAGYO_CD">{{item.SAGYO_NM}}
                                            </option>
                                        </select>
                                        <!-- 完全包装 -->
                                        <select v-if="sh063TdkReqModel.ecoHousouMode == '0'" 
                                            class="noshiCdSelect" 
                                            data-live-search="true"
                                            id="noshiCd"
                                            v-model="sh063TdkReqModel.noshiCd"
                                            style="width:220px;"
                                            :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                            >
                                            <option v-for="item in sh063Init.noshiCdList1" 
                                                :key="item.SAGYO_CD" :value="item.SAGYO_CD">{{item.SAGYO_NM}}
                                            </option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <!-- 包装可、noshiUseFlg:のし利用オプション50506を使用する、giftMode:ギフトモード、ecoHousouMode:エコ包装モード -->
                            <tr class="tableTr" v-if="sh063Init.housouFukaFlg == 1 && sh063Init.noshiUseFlg == 1 && sh063TdkReqModel.giftMode =='1' && sh063TdkReqModel.ecoHousouMode =='1'">
                                <td colspan="2" bgcolor="#FFFFFF" height="60" class="td-res-height">
                                    <div style="display:flex;padding-bottom:12px;">
                                        <!-- 名前 -->
                                        <div class="sh063-meimei-row" style="display:flex;align-items:center;">
                                            <span id="meimeiNm_lbl" style="margin-right:8px;" >
                                                {{$t('sh063.labels.meimeiNm')}}
                                            </span>
                                            <div id="meimeiNmDiv">
                                                <input-check v-model="sh063TdkReqModel.meimeiNm" 
                                                    id="meimeiNm"  
                                                    class="meimeiNmInput"
                                                    :maxlength="16"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                    size="12"  />
                                            </div>
                                        </div>
                                        <!-- 会社名 -->
                                        <div class="sh063-compNm-row" style="display:flex;align-items:center;">
                                            <span id="compNm_lbl" style="margin-right:8px;" >
                                                {{$t('sh063.labels.compNm')}}
                                            </span>
                                            <div id="compNmDiv">
                                                <input-check v-model="sh063TdkReqModel.compNm" 
                                                    id="compNm"  
                                                    class="compNmInput"
                                                    :maxlength="16"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                    size="12"  />
                                            </div>
                                        </div>
                                        <!-- 肩書 -->
                                        <div class="sh063-compKatagaki-row" style="display:flex;align-items:center;">
                                            <span id="compKatagaki_lbl" style="margin-right:8px;" >
                                                {{$t('sh063.labels.compKatagaki')}}
                                            </span>
                                            <div id="compKatagakiDiv">
                                                <input-check v-model="sh063TdkReqModel.compKatagaki" 
                                                    id="compKatagaki"  
                                                    class="compKatagakiInput"
                                                    :maxlength="16"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                    size="12"  />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <!-- 種別 -->
                            <!-- 包装可、noshiUseFlg:のし利用オプション50506を使用する、giftMode:ギフトモード、ecoHousouMode:完全包装モード -->
                            <tr class="tableTr" v-if="sh063Init.housouFukaFlg == 1 && sh063Init.noshiUseFlg == 1 && sh063TdkReqModel.giftMode =='1' && sh063TdkReqModel.ecoHousouMode =='0'">
                                <td colspan="2" bgcolor="#FFFFFF" height="200" class="td-res-height">
                                    <div style="display:flex;padding-bottom:12px;">
                                        <div class="sh063-syubetu1-inline">
                                            <input class="sh063syubetu1Input" 
                                                type="radio" id="syubetu1" name="syubetu" 
                                                :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                value="1" @change="syubetuChanged" v-model="sh063TdkReqModel.syubetu" >
                                            <!-- 個人１名 -->
                                            <label id="syubetu1_lbl" for="syubetu1" style="margin-bottom:0px;padding-right:20px;">
                                                {{$t("sh063.labels.syubetu1")}}</label>
                                        </div>
                                        <div class="sh063-syubetu2-inline">
                                            <input class="sh063syubetu2Input" 
                                                type="radio" id="syubetu2" name="syubetu" 
                                                :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                value="2" @change="syubetuChanged" v-model="sh063TdkReqModel.syubetu"  >
                                            <!-- 名のみ連名 -->
                                            <label id="syubetu2_lbl" for="syubetu2" style="margin-bottom:0px;padding-right:20px;">
                                                {{$t("sh063.labels.syubetu2")}}</label>
                                        </div>
                                        
                                        <div class="sh063-syubetu3-inline">
                                            <input class="sh063syubetu3Input" 
                                                type="radio" id="syubetu3" name="syubetu" 
                                                :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                value="3" @change="syubetuChanged" v-model="sh063TdkReqModel.syubetu"  >
                                            <!-- 個人連名 -->
                                            <label id="syubetu3_lbl" for="syubetu3" style="margin-bottom:0px;padding-right:20px;">
                                                {{$t("sh063.labels.syubetu3")}}</label>
                                        </div>

                                        <div class="sh063-syubetu4-inline">
                                            <input class="sh063syubetu4Input" 
                                                type="radio" id="syubetu4" name="syubetu" 
                                                :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                value="4" @change="syubetuChanged" v-model="sh063TdkReqModel.syubetu"  >
                                            <!-- ルビ付き -->
                                            <label id="syubetu4_lbl" for="syubetu4" style="margin-bottom:0px;padding-right:20px;">
                                                {{$t("sh063.labels.syubetu4")}}</label>
                                        </div>
                                        <div class="sh063-syubetu5-inline">
                                            <input class="sh063syubetu5Input" 
                                                type="radio" id="syubetu5" name="syubetu" 
                                                :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                value="5" @change="syubetuChanged" v-model="sh063TdkReqModel.syubetu"  >
                                            <!-- 法人 -->
                                            <label id="syubetu5_lbl" for="syubetu5" style="margin-bottom:0px;">
                                                {{$t("sh063.labels.syubetu5")}}</label>
                                        </div>
                                    </div>
                                    <!--種別１，２，３-->
                                    <div v-show="sh063TdkReqModel.syubetu=='1' || sh063TdkReqModel.syubetu=='2' || sh063TdkReqModel.syubetu=='3'"
                                        style="display: grid; grid-template-columns: min-content;">
                                        <!--姓１，名１-->
                                        <div class="sh063-simeiSei1-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="simeiSei1Div" style="align-items:center;">
                                                <span id="simeiSei1_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.sei1')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiSei1" 
                                                    id="simeiSei1"
                                                    class="simeiSei1Input"
                                                    style="height:40px;"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                    :maxlength="12"  />
                                            </div>
                                            <div id="simeiMei1Div" style="align-items:center;">
                                                <span id="simeiMei1_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.mei1')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiMei1" 
                                                    id="simeiMei1"
                                                    class="simeiMei1Input"
                                                    style="height:40px;"
                                                    :maxlength="12"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1"
                                                    size="20"  />
                                            </div>
                                        </div>
                                        <!--姓2，名2-->
                                        <div class="sh063-simeiSei2-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="simeiSei2Div" style="align-items:center;">
                                                <span id="simeiSei2_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.sei2')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiSei2" 
                                                    id="simeiSei2"
                                                    class="simeiSei2Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || (sh063TdkReqModel.syubetu=='1' || sh063TdkReqModel.syubetu=='2')"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                            <div id="simeiMei2Div" style="align-items:center;">
                                                <span id="simeiMei2_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.mei2')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiMei2" 
                                                    id="simeiMei2"
                                                    class="simeiMei2Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.syubetu=='1' "
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                        </div>
                                        <!--姓3，名3-->
                                        <div class="sh063-simeiSei3-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="simeiSei3Div" style="align-items:center;">
                                                <span id="sei3_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.sei3')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiSei3" 
                                                    id="simeiSei3"
                                                    class="simeiSei3Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || (sh063TdkReqModel.syubetu=='1' || sh063TdkReqModel.syubetu=='2')"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                            <div id="simeiMei3Div" style="align-items:center;">
                                                <span id="mei3_lbl" style="white-space: nowrap;padding-right:10px;">
                                                    {{$t('sh063.labels.mei3')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiMei3" 
                                                    id="simeiMei3"
                                                    class="simeiMei3Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.syubetu=='1'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                        </div>
                                        <!--姓4，名4-->
                                        <div class="sh063-simeiSei4-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="simeiSei4Div" style="align-items:center;">
                                                <span id="sei4_lbl" style="white-space: nowrap;padding-right:10px;">
                                                    {{$t('sh063.labels.sei4')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiSei4" 
                                                    id="simeiSei4"
                                                    class="simeiSei4Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || (sh063TdkReqModel.syubetu=='1' || sh063TdkReqModel.syubetu=='2')"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                            <div id="simeiMei4Div" style="align-items:center;">
                                                <span id="mei4_lbl" style="white-space: nowrap;padding-right:10px;">
                                                    {{$t('sh063.labels.mei4')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiMei4" 
                                                    id="simeiMei4"
                                                    class="simeiMei4Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.syubetu=='1'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                        </div>
                                        <!--姓5，名-->
                                        <div class="sh063-simeiSei5-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="simeiSei5Div" style="align-items:center;">
                                                <span id="sei5_lbl" style="white-space: nowrap;padding-right:10px;">
                                                    {{$t('sh063.labels.sei5')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiSei5" 
                                                    id="simeiSei5"
                                                    class="simeiSei5Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || (sh063TdkReqModel.syubetu=='1' || sh063TdkReqModel.syubetu=='2')"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                            <div id="simeiMei5Div" style="align-items:center;">
                                                <span id="mei5_lbl" style="white-space: nowrap;padding-right:10px;">
                                                    {{$t('sh063.labels.mei5')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.simeiMei5" 
                                                    id="simeiMei5"
                                                    class="simeiMei5Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.syubetu=='1'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                        </div>
                                    </div>

                                    <!--種別４-->
                                    <div v-show="sh063TdkReqModel.syubetu=='4'" style="display: grid; grid-template-columns: min-content;">
                                        <!--名前１ルビ１-->
                                        <div class="sh063-rubi1-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="namae1Div" style="align-items:center;">
                                                <span id="namae1_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.namae1')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.namae1" 
                                                    id="namae1"
                                                    class="namae1Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                            <div id="rubi1Div" style="align-items:center;">
                                                <span id="rubi1_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.rubi1')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.rubi1" 
                                                    id="rubi1" 
                                                    class="rubi1Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                        </div>

                                        <!--名前２ルビ２-->
                                        <div class="sh063-rubi2-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="namae2Div" style="align-items:center;">
                                                <span id="namae2_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.namae2')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.namae2" 
                                                    id="namae2"
                                                    class="namae2Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20" />
                                            </div>
                                            <div id="rubi2Div" style="align-items:center;">
                                                <span id="rubi2_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.rubi2')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.rubi2" 
                                                    id="rubi2"
                                                    class="rubi2Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                        </div>

                                        <!--名前３ルビ３-->
                                        <div class="sh063-rubi3-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="namae3Div" style="align-items:center;">
                                                <span id="namae3_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.namae3')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.namae3" 
                                                    id="namae3"  
                                                    class="namae3Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                            <div id="rubi3Div" style="align-items:center;">
                                                <span id="rubi3_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.rubi3')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.rubi3" 
                                                    id="rubi3"  
                                                    class="rubi3Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="20"  />
                                            </div>
                                        </div>
                                    </div>

                                    <!--種別５-->
                                    <div v-show="sh063TdkReqModel.syubetu=='5'" style="display: grid; grid-template-columns: min-content;">
                                        <!--会社種別-->
                                        <div class="sh063-compSyubetu-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div class="sh063-compSyubetu-inline" style="align-items:center;">
                                                <span id="compSyubetuCd_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.compSyubetu')}}
                                                </span>
                                                <input class="compSyubetu1Input" 
                                                    type="radio" id="compSyubetu1" name="compSyubetuCd" 
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    value="1" v-model="sh063TdkReqModel.compSyubetuCd"  >
                                                <!-- 前株 -->
                                                <label id="compSyubetu1_lbl" for="compSyubetu1" style="white-space: nowrap;align-items:center;margin:0 5px 0 0;">
                                                    {{$t("sh063.labels.compSyubetu1")}}</label>
                                                <input class="compSyubetu2Input" 
                                                    type="radio" id="compSyubetu2" name="compSyubetuCd" 
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    value="2" v-model="sh063TdkReqModel.compSyubetuCd"  >
                                                <!-- 後株 -->
                                                <label id="compSyubetu2_lbl"  for="compSyubetu2" style="white-space: nowrap;align-items:center;margin:0 5px 0 0;">
                                                    {{$t("sh063.labels.compSyubetu2")}}</label>
                                                <input-check v-model="sh063TdkReqModel.compSyubetuNm" 
                                                    id="compSyubetuNm"  
                                                    class="compSyubetuNmInput"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="10"
                                                    style="height:40px;"
                                                    size="15"  />
                                                <select class="compSyubetuSelect" 
                                                    v-on:change="compSyubetuChange"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    style="height:40px;"
                                                    >
                                                    <option v-for="item in sh063Init.compKindList" 
                                                        :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--会社名-->
                                        <div class="sh063-compNm-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="compNmDiv" style="align-items:center;">
                                                <span id="compNm_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.compNm')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.compNm" 
                                                    id="compNm"  
                                                    class="compNmInput"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="40"
                                                    style="height:40px;"
                                                    size="22"  />
                                            </div>
                                        </div>
                                        <!--部署名-->
                                        <div class="sh063-compBusyo-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="compBusyo1Div" style="align-items:center;">
                                                <span id="compBusyo_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.compBusyo')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.compBusyo1" 
                                                    name="compBusyo1"
                                                    id="compBusyo1"  
                                                    class="compBusyo1Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="50"
                                                    style="height:40px;"
                                                    size="22"  />
                                            </div>
                                            <div id="compBusyo2Div" style="align-items:center;margin:0;">
                                                <input-check v-model="sh063TdkReqModel.compBusyo2" 
                                                    name="compBusyo2"
                                                    id="compBusyo2"  
                                                    class="compBusyo2Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063Init.noshiDispFlg=='0'"
                                                    :maxlength="50"
                                                    style="height:40px;"
                                                    size="22"  />
                                            </div>
                                        </div>
                                        <!--肩書-->
                                        <div class="sh063-compKatagaki-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="compKatagakiDiv" style="align-items:center;">
                                                <span id="compKatagaki_lbl" style="white-space: nowrap;margin:0 15px 0 0;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.compKatagaki')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.compKatagaki" 
                                                    id="compKatagaki"  
                                                    class="compKatagakiInput"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="20"
                                                    style="height:40px;"
                                                    size="22"  />
                                            </div>
                                            <div id="compKatagakiSelectDiv" style="align-items:center;margin:0;">
                                                <select class="compKatagakiSelect" 
                                                        v-on:change="compKatagakiChange"
                                                        :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                        >
                                                    <option v-for="item in sh063Init.compKatagakiList" 
                                                        :key="item.KEY" :value="item.KEY">{{item.VALUE}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <!--個人-->
                                        <div class="sh063-compKojinNm-row" style="display: grid;grid-template-columns: min-content min-content;margin-bottom:5px;align-items:center;">
                                            <div id="compKojinNm1Div" style="align-items:center;">
                                                <span id="compKojinNm_lbl" style="white-space: nowrap;padding-right:10px;align-items:center;">
                                                    {{$t('sh063.labels.compKojinNm')}}
                                                </span>
                                                <input-check v-model="sh063TdkReqModel.compKojinNm1" 
                                                    id="compKojinNm1"  
                                                    class="compKojinNm1Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="22"  />
                                            </div>
                                            <div id="compKojinNm2Div" style="align-items:center;margin:0;">
                                                <input-check v-model="sh063TdkReqModel.compKojinNm2" 
                                                    id="compKojinNm2"  
                                                    class="compKojinNm2Input"
                                                    :disabled="sh063TdkReqModel.noshiOkFlg!=1 || sh063TdkReqModel.noshiDispFlg=='0'"
                                                    :maxlength="12"
                                                    style="height:40px;"
                                                    size="22"  />
                                            </div>
                                        </div>
                                    </div>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="btnSubmitsh063" style="display:flex;justify-content:center;align-items:center;gap:1rem;margin-top:1em;">
                    <!-- 閉じるボタン -->
                    <div style="width:33.3%;"><button class="sh063-btn-back" style="background-color:#a0a0a0;width:100%;padding:0.75em 1.5em;font-size:1em;cursor:pointer;" 
                        @click="showFlg = false" type="button">{{$t("common.buttons.close")}}</button></div>
                    <!-- 変更ボタン -->
                    <div style="width:33.3%;"><button class="sh063-btn-next" style="background-color:#d2323a;width:100%;padding:0.75em 1.5em;font-size:1em;cursor:pointer;" 
                        @click="doUpdate(sh063TdkReqModel.hopeTdkYmd,sh063TdkReqModel.hopeTdkYmdAfter,sh063TdkReqModel.hopeTdkTimeKbn)" type="button">{{$t("common.buttons.change")}}</button></div>
                </div>
            </div>
        </div>
    </div>
</b-modal>
</template>

<script>
import $ from 'jquery';
import common from 'assets/js/common';
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import PageFeed from "../commonParts/PageFeedTdk";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputCheck from "components/InputCheck";
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import EventBus from "assets/js/eventBus";
import Message from 'components/MessageEcSite';
import AlertConfirm from "components/AlertConfirm";

export default {
    name: "SH063TdkHopeDateGiftSetting",
    components: {
        PageFeed,
        InputNumber,
        InputCheck,
        EventBus,
        Loading,
        Breadcrumb,
        AlertConfirm,
        Message
    },
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        data:{
            tdkNo:null,
            tdkSeq:null,
            //お届け希望日
            hopeTdkYmd:null,
            //お届け希望時間
            hopeTdkTimeKbn:null,
            //着日区分
            chakubiKbn:null,
            //お届け希望日必須フラグ
            tdkYmdHissuFlg:null,
            //お届け希望時間必須フラグ
            tdkHstmHissuFlg:null,
            //受取日
            pickupYmd:null
        }
    },
    data: function() {
        return {
            sh063TdkReqModel:{
                tdkNo:null,
                tdkSeq:null,
                tdkMSeq:null,
                //お届け希望日
                hopeTdkYmd:null,
                hopeTdkYmdAfter:null,
                hopeTdkTimeKbn:null,
                //着日区分
                chakubiKbn:null,
                //お届け希望日必須フラグ
                tdkYmdHissuFlg:null,
                //お届け希望時間必須フラグ
                tdkHstmHissuFlg:null,
                updChakubiKbn:null,
                //便種区分
                binsyuKbn:null,
                //包装使用可フラグ
                wappingOkFlg:null,
                //のし使用可フラグ
                noshiOkFlg:null,
                //受取日
                pickupYmd:null,
                //のし
                noshiCd:null,
                //名前
                meimeiNm:null,
                //肩書
                compKatagaki:null,
                //会社名
                compNm:null,
                //種別
                syubetu:'1',
                //姓1～姓5
                simeiSei1:null,
                simeiSei2:null,
                simeiSei3:null,
                simeiSei4:null,
                simeiSei5:null,
                //名1～名5
                simeiMei1:null,
                simeiMei2:null,
                simeiMei3:null,
                simeiMei4:null,
                simeiMei5:null,
                //エコ包装モード（エコ包装を指定した場合、1を設定）
                ecoHousouMode:'1',
                //ギフト設定
                giftCd:0,
                giftMode:'0',
                //のし表示フラグ(50650)
                noshiDispFlg:null,
                copyFlg:null,
            },
            sh063ItemControl:{
                radioGrp1Flg:0,
                radioGrp2Flg:0,
                radioGrp3Flg:0,
                ymdHopeFlg:0,
                ymdAftFlg:0,
                timeHopeFlg:0,
                //受取日フラグ
                pickupYmdFlg:0
            },
            sh063Init:{
                //着日指定 のみ、以降利用オプションオプション（12625）
                chakubiOption:null,
                tdkYmdList:{},
                hopeTimeList:{},
                housouKbnList:[],
                noshiCdList:[],
                noshiCdList1:[],
                //ギフトオプション（50512）
                giftFlg:null,
                //のし利用オプション（50506）
                noshiUseFlg:null,
                //完全包装可フラグ、のし可の商品がない場合、0になる。0:完全包装不可 1:完全包装可
                onlyEcoFlg:1
            },
            queryData:null,
            SiteConstants: SiteConstants,
            showFlg: true,
            site: "",
            SH063_PART:'sh063',
            listMessValid:[],
            mapMessValid:[],
            listIdErr:[],
            isLoading: false
        }
    },
    /*
    * Initialize
    */
    mounted: async function() {
        var _this = this;

        // get length list data
        EventBus.$on("is-loading", function(data) {
            _this.isLoading = data;
        });

        //画面初期化処理
        await _this.doInit();
        _this.doSetItem();
        //console.log('tdkSeq:'+_this.sh063TdkReqModel.tdkSeq);
        //console.log('tdkNo:'+_this.sh063TdkReqModel.tdkNo);
        //console.log('tdkMSeq:'+_this.sh063TdkReqModel.tdkMSeq);
        //console.log('hopeTdkYmd:'+_this.sh063TdkReqModel.hopeTdkYmd);
        //console.log('hopeTdkYmdAfter:'+_this.sh063TdkReqModel.hopeTdkYmdAfter);
        //console.log('hopeTdkTimeKbn:'+_this.sh063TdkReqModel.hopeTdkTimeKbn);
        //console.log('chakubiOption:'+_this.sh063Init.chakubiOption);
        //console.log('chakubiKbn:'+_this.sh063TdkReqModel.chakubiKbn);
        //console.log('updChakubiKbn:'+_this.sh063TdkReqModel.updChakubiKbn);
        //console.log('tdkYmdHissuFlg:'+_this.sh063TdkReqModel.tdkYmdHissuFlg);
        //console.log('tdkYmdErrFlg:'+_this.sh063TdkReqModel.tdkYmdErrFlg);
        //console.log('tdkHstmHissuFlg:'+_this.sh063TdkReqModel.tdkHstmHissuFlg);
        //console.log('tdkHstmErrFlg:'+_this.sh063TdkReqModel.tdkHstmErrFlg);
        //console.log('binsyuKbn:'+_this.sh063TdkReqModel.binsyuKbn);
        //console.log('pickupYmd:'+_this.sh063TdkReqModel.pickupYmd);
        //console.log('wappingOkFlg:'+_this.sh063TdkReqModel.wappingOkFlg);
        //console.log('noshiOkFlg:'+_this.sh063TdkReqModel.noshiOkFlg);
        //console.log('housouFukaFlg:'+_this.sh063TdkReqModel.housouFukaFlg);
    },

    methods: {
        doInit: async function() {
            var _this = this;
            _this.isLoading = true;
            _this.sh063TdkReqModel.tdkNo = _this.data.tdkNo;
            _this.sh063TdkReqModel.tdkSeq = _this.data.tdkSeq;
            _this.sh063TdkReqModel.tdkMSeq = _this.data.tdkMSeq;
            _this.sh063TdkReqModel.tdkFlg = _this.data.tdkFlg;
            _this.sh063TdkReqModel.chakubiKbn = _this.data.chakubiKbn;//着日区分 0：なし 1：のみ 2：以降 デフォルト＝０
            _this.sh063TdkReqModel.updChakubiKbn = _this.data.updChakubiKbn;//着日区分 0：なし 1：のみ 2：以降 デフォルト＝０
            _this.sh063TdkReqModel.hopeTdkTimeKbn = _this.data.tdkHmsKbn;//お届け時間帯区分
            if(_this.sh063TdkReqModel.updChakubiKbn == '1'){
                _this.sh063TdkReqModel.hopeTdkYmd = _this.data.tdkYmd;//お届け希望日（のみ）
            } else if(_this.sh063TdkReqModel.updChakubiKbn == '2'){
                _this.sh063TdkReqModel.hopeTdkYmdAfter = _this.data.tdkYmd;//お届け希望日（以降）
            } else {
                _this.sh063TdkReqModel.hopeTdkYmd = _this.data.tdkYmd;//お届け希望日（のみ）
            }
            
            _this.sh063TdkReqModel.tdkYmdHissuFlg = _this.data.tdkYmdHissuFlg;//着日必須フラグ １：のみ ２：以降 デフォルト＝０ 
            _this.sh063TdkReqModel.tdkYmdErrFlg = _this.data.tdkYmdErrFlg;//着日指定不可フラグ デフォルト＝０
            _this.sh063TdkReqModel.tdkHstmHissuFlg = _this.data.tdkHstmHissuFlg;//配達時間帯必須フラグ デフォルト＝０
            _this.sh063TdkReqModel.tdkHstmErrFlg = _this.data.tdkHstmErrFlg;//

            _this.sh063TdkReqModel.binsyuKbn = _this.data.binsyuKbn;//便種区分 90:店頭受取
            
            //受取の場合
            if(common.stringNvl(_this.sh063TdkReqModel.binsyuKbn)=='90'){
                _this.sh063TdkReqModel.pickupYmd = _this.data.tdkYmd;        //受取日
            }

            //包装可商品ありフラグ
            _this.sh063TdkReqModel.wappingOkFlg = _this.data.wappingOkFlg;

            //のし可商品ありフラグ
            _this.sh063TdkReqModel.noshiOkFlg = _this.data.noshiOkFlg;

            _this.site = _this.$router.history.current.fullPath.split("/")[1];
            await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH063 + _this.$UrlConstants.DO_INIT, _this.sh063TdkReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                }else{
                    _this.sh063Init = response.data;
                    _this.sh063TdkReqModel = Object.assign({}, _this.sh063TdkReqModel, response.data.reqModel);
                }
                _this.$forceUpdate();
            }).catch(function(error) {
                _this.isLoading = false;
                common.errorAPI(error);
            });

        },
        
        /**
         * doSetItem
         */
        doSetItem() {
            var _this = this;

            //制御マトリクスで制御処理を行う
            //着日区分 0：なし 1：のみ 2：以降 デフォルト＝０
            //着日必須フラグ １：のみ ２：以降 デフォルト＝０
            _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
            _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
            _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可能
            _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可能
            _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
            _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
            
            //1行目
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可能
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                //console.log('1行目');
            }
            //2行目
            if(_this.sh063Init.chakubiOption == 1
                    &&  common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 1
                    && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //〇 のみ（顧客指定付き）
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                //console.log('2行目');
            } else if (_this.sh063Init.chakubiOption == 1
                    &&  common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 2
                    && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //3行目
            //〇 以降（顧客指定無し）
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                //console.log('3行目');
            } else if (_this.sh063Init.chakubiOption == 1
                    &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == '' || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                    && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                //console.log('3行目-1');
            }
            //4行目
            //〇 着日 指定不可フラグ＝１
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 1 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                //console.log('4行目');
            }
            //5行目
            //配達時間 必須フラグ＝１
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0 
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可能
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                //console.log('5行目');
            }
            //6行目
            if(_this.sh063Init.chakubiOption == 1
                &&  common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 1
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //〇 のみ（顧客指定付き） かつ 配達時間 必須フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                //console.log('6行目');
            } else if (_this.sh063Init.chakubiOption == 1
                &&  common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 2
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //7行目
            //〇 以降（顧客指定無し） かつ 配達時間 必須フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                //console.log('7行目');
            } else if (_this.sh063Init.chakubiOption == 1
                &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == '' || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                //console.log('7行目-1');
            }
            //8行目
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 1
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 1
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 0){
            //〇 着日 指定不可フラグ＝１ かつ 配達時間 必須フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能
                _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                //console.log('8行目');
            }
            //9行目
            //配達時間 指定不可フラグ＝１
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkYmdErrFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                    && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可能
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                //console.log('9行目');
            }
            //10行目
            if(_this.sh063Init.chakubiOption == 1
                &&  common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 1
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
            //〇 のみ（顧客指定付き） かつ 配達時間 指定不可フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                //console.log('10行目');
            } else if (_this.sh063Init.chakubiOption == 1
                &&  common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 2
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
            //11行目
            //〇 以降（顧客指定無し） かつ 配達時間 指定不可フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                //console.log('11行目');
            } else if (_this.sh063Init.chakubiOption == 1
                &&  (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == '' || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0)
                && _this.sh063TdkReqModel.tdkYmdHissuFlg == 1 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 0 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可
                _this.sh063ItemControl.radioGrp3Flg = 1;        //以降 ラジオボタン 使用可
                _this.sh063ItemControl.ymdAftFlg = 1;           //以降 お届け希望日 使用可
                _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                _this.sh063TdkReqModel.radioGroup1 = 2          //以降 ラジオボタンを選択状態にする
                //console.log('11行目-1');
            }
            //12行目
            if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 0 
                && _this.sh063TdkReqModel.tdkYmdErrFlg == 1 
                && _this.sh063TdkReqModel.tdkHstmHissuFlg == 0
                && _this.sh063TdkReqModel.tdkHstmErrFlg == 1){
            //〇 着日 指定不可フラグ＝１ かつ 配達時間 指定不可フラグ＝１
                _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可
                _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                //console.log('12行目');
            }
            //着日オプション使用
            if(_this.sh063Init.chakubiOption == 1){
                //のみを設定した場合(商品マスタ)
                if (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 1){
                    _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                    _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                    //console.log('13');
                } else if (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 2){
                //以降を設定した場合(商品マスタ)
                    _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                    _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                    //console.log('14');
                }
                //のみを設定した場合(ワーク)
                if (common.stringNvl(_this.sh063TdkReqModel.updChakubiKbn) == 1){//のみを指定
                    if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmd)==''){
                        _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                    } else {
                        _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                    }
                    //console.log('15');
                } else if (common.stringNvl(_this.sh063TdkReqModel.updChakubiKbn) == 2){//以降を指定
                //以降を設定した場合(ワーク)
                    if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmdAfter)==''){
                        _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                    } else {
                        _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                    }
                    //console.log('16');
                } else if (common.stringNvl(_this.sh063TdkReqModel.updChakubiKbn) == '' || common.stringNvl(_this.sh063TdkReqModel.updChakubiKbn) == 0){//指定なし
                    if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmd)!=''){
                        _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                        console.log('19');
                    } else if (common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmdAfter)!=''){
                        _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                        //console.log('17');
                    } else {
                        if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 1){//希望日指定必須
                            //商品マスタの設定をみて設定する必要がある。
                            if (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == '' || common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == 0){
                                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                            } else if (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == '1'){
                                _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                            } else if (common.stringNvl(_this.sh063TdkReqModel.chakubiKbn) == '2'){
                                _this.sh063TdkReqModel.radioGroup1 = 3          //以降 ラジオボタンを選択状態にする
                            }
                        } else {
                            _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                        }
                        //console.log('18');
                    }
                }
            } else {
                if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmd)==''){
                    _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                } else {
                    _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                }
                //console.log('19');
            }
            //追加パターン
            //希望日		時間	
            //必須	不可	必須	不可
            //1	0	1	0
            //0	1	1	0→希望日指定不可
            //0	0	1	0
                        
            //1	0	0	1               →時間指定不可
            //0	1	0	1→希望日指定不可 →時間指定不可
            //0	0	0	1               →時間指定不可
                        
            //1	0	0	0
            //0	1	0	0→希望日指定不可
            //0	0	0	0
            if (_this.sh063Init.chakubiOption == 0){//着日指定 のみ、以降利用オプション
                _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                _this.sh063ItemControl.radioGrp3Flg = 0;        //以降 ラジオボタン 使用不可
                _this.sh063ItemControl.ymdAftFlg = 0;           //以降 お届け希望日 使用不可
                _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                _this.sh063ItemControl.timeHopeFlg = 1;         //希望時間 使用可能

                //希望日指定必須
                if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 1){
                    _this.sh063ItemControl.radioGrp2Flg = 1;        //のみ ラジオボタン 使用可能
                    _this.sh063ItemControl.ymdHopeFlg = 1;          //のみ お届け希望日 使用可能
                    _this.sh063ItemControl.radioGrp1Flg = 0;        //指定なし ラジオボタン 使用不可
                    //console.log('20');
                }
                //希望日指定不可
                if(_this.sh063TdkReqModel.tdkYmdErrFlg == 1){
                    _this.sh063ItemControl.radioGrp2Flg = 0;        //のみ ラジオボタン 使用不可
                    _this.sh063ItemControl.ymdHopeFlg = 0;          //のみ お届け希望日 使用不可
                    _this.sh063ItemControl.radioGrp1Flg = 1;        //指定なし ラジオボタン 使用可能
                    //console.log('21');
                }
                //時間指定不可
                if(_this.sh063TdkReqModel.tdkHstmErrFlg == 1){
                    _this.sh063ItemControl.timeHopeFlg = 0;         //希望時間 使用不可
                    //console.log('22');
                }
                if(common.stringNvl(_this.sh063TdkReqModel.hopeTdkYmd)==''){
                    if(_this.sh063TdkReqModel.tdkYmdHissuFlg == 1){//希望日指定必須
                        _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                    } else {
                        _this.sh063TdkReqModel.radioGroup1 = 1          //指定なし ラジオボタンを選択状態にする
                    }
                    //console.log('23');
                } else {
                    _this.sh063TdkReqModel.radioGroup1 = 2          //のみ ラジオボタンを選択状態にする
                }
            }
            
            //受取の場合
            if(common.stringNvl(_this.sh063TdkReqModel.binsyuKbn)=='90'){
                _this.sh063ItemControl.pickupYmdFlg = _this.sh063ItemControl.ymdHopeFlg;        //受取日
            }

            //console.log('radioGrp2Flg:'+_this.sh063ItemControl.radioGrp2Flg);
            //console.log('ymdHopeFlg:'+_this.sh063ItemControl.ymdHopeFlg);
            //console.log('radioGrp3Flg:'+_this.sh063ItemControl.radioGrp3Flg);
            //console.log('ymdAftFlg:'+_this.sh063ItemControl.ymdAftFlg);
            //console.log('radioGrp1Flg:'+_this.sh063ItemControl.radioGrp1Flg);
            //console.log('timeHopeFlg:'+_this.sh063ItemControl.timeHopeFlg);
            
            //ギフト設定、ギフトをデフォルトに設定。
            if(_this.sh063TdkReqModel.giftCd == undefined || _this.sh063TdkReqModel.giftCd == null || _this.sh063TdkReqModel.giftCd == ''){
                _this.sh063TdkReqModel.giftCd = '1';//ギフト
            }
            _this.sh063TdkReqModel.giftMode = '1';

            //console.log('_this.sh063TdkReqModel.housouKbn start:'+_this.sh063TdkReqModel.housouKbn);
            //console.log('_this.sh063TdkReqModel.housouKbnNm start:'+_this.sh063TdkReqModel.housouKbnNm);
            //console.log('_this.sh063TdkReqModel.noshiCd start:'+_this.sh063TdkReqModel.noshiCd);

            //エコ包装設定
            if(_this.sh063TdkReqModel.housouKbn == undefined || _this.sh063TdkReqModel.housouKbn == null || _this.sh063TdkReqModel.housouKbn == ''){
                //エコ包装を取得
                var defaultHousouItem = null;
                //エコ包装の梱包作業指示コード(包装紙)が設定あり
                if(_this.sh063Init.ecoHousouLst != null && _this.sh063Init.ecoHousouLst != undefined){
                    //包装区分リストが設定あり
                    if(_this.sh063Init.housouKbnList != null && _this.sh063Init.housouKbnList != undefined){
                        defaultHousouItem = _this.sh063Init.housouKbnList.find(item => _this.sh063Init.ecoHousouLst.includes(item.SAGYO_CD));
                    }
                }
                if (defaultHousouItem != null && defaultHousouItem.SAGYO_CD != undefined && defaultHousouItem.SAGYO_CD != null && defaultHousouItem.SAGYO_CD != ''){
                    _this.sh063TdkReqModel.housouKbn = defaultHousouItem.SAGYO_CD;
                    _this.sh063TdkReqModel.housouKbnNm = defaultHousouItem.SAGYO_NM;
                    //エコ包装
                    _this.sh063TdkReqModel.ecoHousouMode = '1';
                    //console.log('_this.sh063TdkReqModel.housouKbn1:'+_this.sh063TdkReqModel.housouKbn);
                    //console.log('_this.sh063TdkReqModel.housouKbnNm1:'+_this.sh063TdkReqModel.housouKbnNm);
                } else {
                    //エコ包装の梱包作業指示コード(包装紙)が設定ない、または、包装区分リストが設定なし
                    if(_this.sh063Init.housouKbnList != null && _this.sh063Init.housouKbnList != undefined){
                        if(_this.sh063Init.housouKbnList.length > 0){
                            //包装区分リストにあるものが、エコ包装リストに存在しない場合、一個目を設定
                            _this.sh063TdkReqModel.housouKbn = this.sh063Init.housouKbnList[0].SAGYO_CD;
                            _this.sh063TdkReqModel.housouKbnNm = this.sh063Init.housouKbnList[0].SAGYO_NM;
                        }
                    } else {
                        _this.sh063TdkReqModel.housouKbn = '';
                        _this.sh063TdkReqModel.housouKbnNm = '';
                    }
                    //エコ包装 以外
                    _this.sh063TdkReqModel.ecoHousouMode = '0';//エコ包装以外
                    //console.log('_this.sh063TdkReqModel.ecoHousouMode2:'+_this.sh063TdkReqModel.ecoHousouMode);
                    //console.log('_this.sh063TdkReqModel.housouKbn2:'+_this.sh063TdkReqModel.housouKbn);
                    //console.log('_this.sh063TdkReqModel.housouKbnNm2:'+_this.sh063TdkReqModel.housouKbnNm);
                }
            } else {
                //エコ包装を取得
                if(_this.sh063Init.ecoHousouLst != null && _this.sh063Init.ecoHousouLst != undefined){
                    if(_this.sh063Init.ecoHousouLst.includes(_this.sh063TdkReqModel.housouKbn)){
                        //エコ包装
                        _this.sh063TdkReqModel.ecoHousouMode = '1';
                    } else {
                        //エコ包装 以外
                        _this.sh063TdkReqModel.ecoHousouMode = '0';
                    }
                } else {
                        //エコ包装 以外
                        _this.sh063TdkReqModel.ecoHousouMode = '0';
                }
                _this.sh063TdkReqModel.housouKbnNm = _this.sh063Init.housouKbnList.find(el => el['SAGYO_CD'] === _this.sh063TdkReqModel.housouKbn)['SAGYO_NM'];
                //console.log('_this.sh063TdkReqModel.housouKbn3:'+_this.sh063TdkReqModel.housouKbn);
                //console.log('_this.sh063TdkReqModel.housouKbnNm3:'+_this.sh063TdkReqModel.housouKbnNm);
            }

            //console.log('_this.sh063TdkReqModel.housouKbn end:'+_this.sh063TdkReqModel.housouKbn);
            //console.log('_this.sh063TdkReqModel.housouKbnNm end:'+_this.sh063TdkReqModel.housouKbnNm);

            //のし初期設定
            if(_this.sh063TdkReqModel.noshiCd == undefined || _this.sh063TdkReqModel.noshiCd == null || _this.sh063TdkReqModel.noshiCd == ''){
                if(_this.sh063TdkReqModel.ecoHousouMode == '1'){//エコ包装
                    //1件目を設定
                    if(_this.sh063Init.noshiCdList != null && _this.sh063Init.noshiCdList != undefined){
                        if(_this.sh063Init.noshiCdList.length > 0){
                            _this.sh063TdkReqModel.noshiCd = this.sh063Init.noshiCdList[0].SAGYO_CD;
                        }
                    }
                } else {//完全包装
                    //1件目を設定
                    if(_this.sh063Init.noshiCdList1 != null && _this.sh063Init.noshiCdList1 != undefined){
                        if(_this.sh063Init.noshiCdList1.length > 0){
                            _this.sh063TdkReqModel.noshiCd = this.sh063Init.noshiCdList1[0].SAGYO_CD;
                        }
                    }
                }
            } else {
                var defaultnoshiCd = null;
                //console.log('_this.sh063TdkReqModel.noshiCd0:'+_this.sh063TdkReqModel.noshiCd);
                if(_this.sh063TdkReqModel.ecoHousouMode == '1'){//エコ包装
                    defaultnoshiCd = _this.sh063Init.noshiCdList.find(el => el['SAGYO_CD'] === _this.sh063TdkReqModel.noshiCd);
                    //console.log('defaultnoshiCd:'+defaultnoshiCd);
                    if (defaultnoshiCd != null && defaultnoshiCd.SAGYO_CD != undefined && defaultnoshiCd.SAGYO_CD != null && defaultnoshiCd.SAGYO_CD != ''){
                        _this.sh063TdkReqModel.noshiCd = defaultnoshiCd.SAGYO_CD;
                    } else {
                        _this.sh063TdkReqModel.noshiCd = this.sh063Init.noshiCdList[0].SAGYO_CD;
                    }
                    //console.log('_this.sh063TdkReqModel.noshiCd1:'+_this.sh063TdkReqModel.noshiCd);
                } else {//完全包装
                    defaultnoshiCd = _this.sh063Init.noshiCdList1.find(el => el['SAGYO_CD'] === _this.sh063TdkReqModel.noshiCd);
                    if (defaultnoshiCd != null && defaultnoshiCd.SAGYO_CD != undefined && defaultnoshiCd.SAGYO_CD != null && defaultnoshiCd.SAGYO_CD != ''){
                        _this.sh063TdkReqModel.noshiCd = defaultnoshiCd.SAGYO_CD;
                    } else {
                        _this.sh063TdkReqModel.noshiCd = this.sh063Init.noshiCdList1[0].SAGYO_CD;
                    }
                    //console.log('_this.sh063TdkReqModel.noshiCd2:'+_this.sh063TdkReqModel.noshiCd);
                }
            }
            //console.log('_this.sh063TdkReqModel.noshiCd end:'+_this.sh063TdkReqModel.noshiCd);

            //受取の場合
            if(common.stringNvl(_this.sh063TdkReqModel.binsyuKbn)=='90'){
                _this.sh063TdkReqModel.radioGroup1 = 2          //受取日 ラジオボタンを選択状態にする
            }

            //包装不可フラグ
            _this.sh063TdkReqModel.housouFukaFlg = _this.sh063Init.housouFukaFlg;//1:包装可 0:包装不可

            //のし可商品がない場合
            if(_this.sh063TdkReqModel.noshiOkFlg != 1){//1:のし使用可商品あり
                _this.sh063TdkReqModel.noshiCd = '';
            }

            _this.isLoading = false;

        },
        syubetuChanged() {
            var _this = this;

            if(_this.sh063TdkReqModel.syubetu == '1'){//個人1名
                _this.sh063TdkReqModel.simeiSei2 = '';
                _this.sh063TdkReqModel.simeiSei3 = '';
                _this.sh063TdkReqModel.simeiSei4 = '';
                _this.sh063TdkReqModel.simeiSei5 = '';
                
                _this.sh063TdkReqModel.simeiMei2 = '';
                _this.sh063TdkReqModel.simeiMei3 = '';
                _this.sh063TdkReqModel.simeiMei4 = '';
                _this.sh063TdkReqModel.simeiMei5 = '';
            }
            if(_this.sh063TdkReqModel.syubetu == '2'){//名のみ連名
                _this.sh063TdkReqModel.simeiSei2 = '';
                _this.sh063TdkReqModel.simeiSei3 = '';
                _this.sh063TdkReqModel.simeiSei4 = '';
                _this.sh063TdkReqModel.simeiSei5 = '';

            }
            if(_this.sh063TdkReqModel.syubetu == '5'){//法人
                if(_this.sh063TdkReqModel.compSyubetuCd == undefined || _this.sh063TdkReqModel.compSyubetuCd == null || _this.sh063TdkReqModel.compSyubetuCd == ''){
                    _this.sh063TdkReqModel.compSyubetuCd = '1';//初期化 前株を設定
                }
            }
            this.$forceUpdate();
        },
        housouKbnChange: function() {
            var _this = this;
            //エコ包装
            var housouKbnNm = null;
            if(_this.sh063Init.housouKbnList != null && _this.sh063Init.housouKbnList != undefined){
                housouKbnNm = _this.sh063Init.housouKbnList.find(item => item.SAGYO_CD === _this.sh063TdkReqModel.housouKbn);
            }
            if(housouKbnNm != null && housouKbnNm.SAGYO_NM != undefined && housouKbnNm.SAGYO_NM != null && housouKbnNm.SAGYO_NM != ''){
                //エコ包装の梱包作業指示コード(包装紙)
                if(_this.sh063Init.ecoHousouLst != null && _this.sh063Init.ecoHousouLst != undefined){
                    if(_this.sh063Init.ecoHousouLst.includes(housouKbnNm.SAGYO_CD)) {
                        //エコ包装
                        _this.sh063TdkReqModel.ecoHousouMode = '1';
                    } else {
                        //エコ包装 以外
                        _this.sh063TdkReqModel.ecoHousouMode = '0';
                    }
                    _this.sh063TdkReqModel.housouKbnNm = housouKbnNm.SAGYO_NM;
                } else {
                    //エコ包装 以外
                    _this.sh063TdkReqModel.ecoHousouMode = '0';
                }
                //console.log('_this.sh063TdkReqModel.ecoHousouMode1:'+_this.sh063TdkReqModel.ecoHousouMode);
                //console.log('_this.sh063TdkReqModel.housouKbn1:'+_this.sh063TdkReqModel.housouKbn);
                //console.log('_this.sh063TdkReqModel.housouKbnNm1:'+_this.sh063TdkReqModel.housouKbnNm);
            } else {
                //エコ包装
                _this.sh063TdkReqModel.ecoHousouMode = '1';
                _this.sh063TdkReqModel.housouKbnNm = '';
                //console.log('_this.sh063TdkReqModel.ecoHousouMode2:'+_this.sh063TdkReqModel.ecoHousouMode);
                //console.log('_this.sh063TdkReqModel.housouKbn2:'+_this.sh063TdkReqModel.housouKbn);
                //console.log('_this.sh063TdkReqModel.housouKbnNm2:'+_this.sh063TdkReqModel.housouKbnNm);
            }

            if(_this.sh063TdkReqModel.noshiCd == undefined || _this.sh063TdkReqModel.noshiCd == null || _this.sh063TdkReqModel.noshiCd == ''){
                if(_this.sh063TdkReqModel.ecoHousouMode == '1'){//エコ包装
                    //1件目を設定
                    if(_this.sh063Init.noshiCdList != null && _this.sh063Init.noshiCdList != undefined){
                        if(_this.sh063Init.noshiCdList.length > 0){
                            _this.sh063TdkReqModel.noshiCd = this.sh063Init.noshiCdList[0].SAGYO_CD;
                        }
                    }
                } else {//完全包装
                    //1件目を設定
                    if(_this.sh063Init.noshiCdList1 != null && _this.sh063Init.noshiCdList1 != undefined){
                        if(_this.sh063Init.noshiCdList1.length > 0){
                            _this.sh063TdkReqModel.noshiCd = this.sh063Init.noshiCdList1[0].SAGYO_CD;
                        }
                    }
                }
            } else {
                var defaultnoshiCd = null;
                if(_this.sh063TdkReqModel.ecoHousouMode == '1'){//エコ包装
                    defaultnoshiCd = _this.sh063Init.noshiCdList.find(el => el['SAGYO_CD'] === _this.sh063TdkReqModel.noshiCd);
                    console.log('defaultnoshiCd:'+defaultnoshiCd);
                    if (defaultnoshiCd != null && defaultnoshiCd.SAGYO_CD != undefined && defaultnoshiCd.SAGYO_CD != null && defaultnoshiCd.SAGYO_CD != ''){
                        _this.sh063TdkReqModel.noshiCd = defaultnoshiCd.SAGYO_CD;
                    } else {
                        _this.sh063TdkReqModel.noshiCd = this.sh063Init.noshiCdList[0].SAGYO_CD;
                    }
                    console.log('_this.sh063TdkReqModel.noshiCd1:'+_this.sh063TdkReqModel.noshiCd);
                } else {//完全包装
                    defaultnoshiCd = _this.sh063Init.noshiCdList1.find(el => el['SAGYO_CD'] === _this.sh063TdkReqModel.noshiCd);
                    if (defaultnoshiCd != null && defaultnoshiCd.SAGYO_CD != undefined && defaultnoshiCd.SAGYO_CD != null && defaultnoshiCd.SAGYO_CD != ''){
                        _this.sh063TdkReqModel.noshiCd = defaultnoshiCd.SAGYO_CD;
                    } else {
                        _this.sh063TdkReqModel.noshiCd = this.sh063Init.noshiCdList1[0].SAGYO_CD;
                    }
                    //console.log('_this.sh063TdkReqModel.noshiCd2:'+_this.sh063TdkReqModel.noshiCd);
                }
            }
            
            this.$forceUpdate();
        },
        compSyubetuChange(e){//会社種別
            var value = e.target.value;
            var itemList = this.sh063Init.compKindList;
            for (var i = 0; i < itemList.length; i++) {
                if (itemList[i].KEY == value){
                    this.sh063TdkReqModel.compSyubetuNm = itemList[i].VALUE;
                    this.$forceUpdate();
                }
            }
        },
        compKatagakiChange(e){//肩書
            var value = e.target.value;
            var itemList = this.sh063Init.compKatagakiList;
            for (var i = 0; i < itemList.length; i++) {
                if (itemList[i].KEY == value){
                    this.sh063TdkReqModel.compKatagaki = itemList[i].VALUE;
                    this.$forceUpdate();
                }
            }
        },
        /**
         * doUpdate
         * @param {String} hopeTdkYmd
         * @param {String} hopeTdkYmdAfter
         * @param {String} hopeTdkTimeKbn
         */
        doUpdate: async function(hopeTdkYmd,hopeTdkYmdAfter,hopeTdkTimeKbn){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH063_PART);
            var rs;
            _this.sh063TdkReqModel.tdkSeq = _this.data.tdkSeq;
            _this.sh063TdkReqModel.tdkNo = _this.data.tdkNo;
            _this.sh063TdkReqModel.hopeTdkYmd = hopeTdkYmd;
            _this.sh063TdkReqModel.hopeTdkYmdAfter = hopeTdkYmdAfter;
            _this.sh063TdkReqModel.hopeTdkTimeKbn = hopeTdkTimeKbn;
            _this.sh063TdkReqModel.updateFlg = '1';
            
            //店頭受取以外の場合
            if(common.stringNvl(_this.sh063TdkReqModel.binsyuKbn)!='90'){

                if(_this.sh063Init.chakubiOption == 1 || _this.sh063Init.chakubiOption == 2){//0：なし 1：のみ 2：以降

                    //お届け希望日指定
                    if(common.stringNvl(_this.sh063TdkReqModel.tdkYmdHissuFlg) == '1'
                        && common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '2' && _this.sh063Init.tdkKibouFlg == 1){//のみ 必須
                            if (_this.sh063TdkReqModel.hopeTdkYmd == null || _this.sh063TdkReqModel.hopeTdkYmd == '' || _this.sh063TdkReqModel.hopeTdkYmd == undefined) {
                                alert("「お届け日指定」欄の希望日を指定してください。");
                                return false;
                            }
                    }

                    //または、以降にお届け
                    if(common.stringNvl(_this.sh063TdkReqModel.tdkYmdHissuFlg) == '1'
                        && common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '3' && _this.sh063Init.tdkKibouFlg == 1){//以降 必須
                            if (_this.sh063TdkReqModel.hopeTdkYmdAfter == null || _this.sh063TdkReqModel.hopeTdkYmdAfter == '' || _this.sh063TdkReqModel.hopeTdkYmdAfter == undefined) {
                                alert("「以降にお届け」欄の希望日を指定してください。");
                                return false;
                            }
                    }

                    if(common.stringNvl(_this.sh063TdkReqModel.tdkYmdHissuFlg) == '1'
                        && common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '1' && _this.sh063Init.tdkKibouFlg == 1){
                            alert("希望日を指定してください。");
                            return false;
                    }

                    //希望時間
                    //console.log('_this.sh063TdkReqModel.hopeTdkTimeKbn:'+_this.sh063TdkReqModel.hopeTdkTimeKbn);
                    if(common.stringNvl(_this.sh063TdkReqModel.tdkHstmHissuFlg) == '1' && _this.sh063Init.tdkTimeFlg == 1){//必須
                        if (_this.sh063TdkReqModel.hopeTdkTimeKbn == null || _this.sh063TdkReqModel.hopeTdkTimeKbn == '' 
                        || _this.sh063TdkReqModel.hopeTdkTimeKbn == undefined || _this.sh063TdkReqModel.hopeTdkTimeKbn == '0') {
                            alert("希望時間を指定してください。");
                            return false;
                        }
                    }
                } else {//0：なし 1：のみ 2：以降
                    //お届け希望日必須 //配送指定日利用オプション 50504
                    if(common.stringNvl(_this.sh063TdkReqModel.tdkYmdHissuFlg) == '1' && _this.sh063Init.tdkKibouFlg == 1){//必須
                        if (_this.sh063TdkReqModel.hopeTdkYmd == null || _this.sh063TdkReqModel.hopeTdkYmd == '' || _this.sh063TdkReqModel.hopeTdkYmd == undefined) {
                            alert("お届け希望日を指定してください。");
                            return false;
                        }
                    }
                    //希望時間 //配送希望時間利用オプション 50505
                    if(common.stringNvl(_this.sh063TdkReqModel.tdkHstmHissuFlg) == '1' && _this.sh063Init.tdkTimeFlg == 1){//必須
                        if (_this.sh063TdkReqModel.hopeTdkTimeKbn == null || _this.sh063TdkReqModel.hopeTdkTimeKbn == '' 
                        || _this.sh063TdkReqModel.hopeTdkTimeKbn == undefined || _this.sh063TdkReqModel.hopeTdkTimeKbn == '0') {
                            alert("希望時間を指定してください。");
                            return false;
                        }
                    }
                }
            }

            //受取日
            if(common.stringNvl(_this.sh063TdkReqModel.binsyuKbn)=='90'){
                //商品マスタ.着日必須の場合チェックをしてエラーメッセージを表示。
                if(common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '2' && common.stringNvl(_this.sh063TdkReqModel.tdkYmdHissuFlg) == '1'){
                    if (_this.sh063TdkReqModel.pickupYmd == null || _this.sh063TdkReqModel.pickupYmd == '' || _this.sh063TdkReqModel.pickupYmd == undefined) {
                        alert("受取日を指定してください。");
                        return false;
                    }
                }
            }

            if(common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '1'){//指定なし
                _this.sh063TdkReqModel.hopeTdkYmd = '';
                _this.sh063TdkReqModel.hopeTdkYmdAfter = '';
                _this.sh063TdkReqModel.updChakubiKbn = '0';//画面で選定した着日区分(0：指定なし)
            } else if(common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '2'){//のみ
                _this.sh063TdkReqModel.hopeTdkYmd = hopeTdkYmd;
                _this.sh063TdkReqModel.hopeTdkYmdAfter = '';
                _this.sh063TdkReqModel.updChakubiKbn = '1';//画面で選定した着日区分(1：のみ)
            } else if(common.stringNvl(_this.sh063TdkReqModel.radioGroup1) == '3'){//以降
                _this.sh063TdkReqModel.hopeTdkYmd = '';
                _this.sh063TdkReqModel.hopeTdkYmdAfter = hopeTdkYmdAfter;
                _this.sh063TdkReqModel.updChakubiKbn = '2';//画面で選定した着日区分(2：以降)
            }

            //console.log('_this.sh063TdkReqModel.housouKbn:'+_this.sh063TdkReqModel.housouKbn);
            //console.log('_this.sh063TdkReqModel.giftMode:'+_this.sh063TdkReqModel.giftMode);
            //console.log('_this.sh063TdkReqModel.giftCd:'+_this.sh063TdkReqModel.giftCd);
            //包装
            if(_this.sh063Init.giftFlg == 1 && _this.sh063TdkReqModel.giftMode == '1' && _this.sh063Init.housouFukaFlg == 1){//ギフト
                if(_this.sh063TdkReqModel.housouKbn == undefined || _this.sh063TdkReqModel.housouKbn == null || _this.sh063TdkReqModel.housouKbn == ''){
                    alert("包装を指定してください。");
                    return false;
                }
            }

            //console.log('_this.sh063TdkReqModel.hopeTdkYmd:'+_this.sh063TdkReqModel.hopeTdkYmd);
            //console.log('_this.sh063TdkReqModel.hopeTdkYmdAfter:'+_this.sh063TdkReqModel.hopeTdkYmdAfter);
            //console.log('_this.sh063TdkReqModel.updChakubiKbn:'+_this.sh063TdkReqModel.updChakubiKbn);

            //エコ包装
            var noshiCdList;
            if(_this.sh063TdkReqModel.ecoHousouMode == '1'){
                noshiCdList = _this.sh063Init.noshiCdList;
            } else {
                noshiCdList = _this.sh063Init.noshiCdList1;
            }
            //console.log('_this.sh063TdkReqModel.noshiCd:'+_this.sh063TdkReqModel.noshiCd);
            if(!common.isNullItem(_this.sh063TdkReqModel.noshiCd)){
                _this.sh063TdkReqModel.noshiNm = noshiCdList.find(el => el['SAGYO_CD'] === _this.sh063TdkReqModel.noshiCd)['SAGYO_NM'];
            }
            //console.log('_this.sh063TdkReqModel.noshiNm:'+_this.sh063TdkReqModel.noshiNm);
            //console.log('_this.sh063TdkReqModel.housouKbn:'+_this.sh063TdkReqModel.housouKbn);
            if(!common.isNullItem(_this.sh063TdkReqModel.housouKbn)){
                _this.sh063TdkReqModel.housouKbnNm = _this.sh063Init.housouKbnList.find(el => el['SAGYO_CD'] === _this.sh063TdkReqModel.housouKbn)['SAGYO_NM'];
            }
            //console.log('_this.sh063TdkReqModel.housouKbnNm:'+_this.sh063TdkReqModel.housouKbnNm);

            //エコ包装
            if(_this.sh063TdkReqModel.ecoHousouMode == '1'){
                var noshiName = _this.sh063TdkReqModel.noshiNm;
                var housouKbnNm = _this.sh063TdkReqModel.housouKbnNm;
                //のし可商品ありフラグ1:のし可商品あり、0:のし可商品なし
                //包装可フラグ1:包装可、0:包装不可
                if(_this.sh063TdkReqModel.noshiOkFlg == 1 && _this.sh063Init.housouFukaFlg == 1 ){
                    _this.sh063TdkReqModel.sagyoNm = noshiName + ' ' + housouKbnNm;
                } else if (this.sh063TdkReqModel.noshiOkFlg == 1 && _this.sh063Init.housouFukaFlg == 0){
                    _this.sh063TdkReqModel.sagyoNm = noshiName;
                } else if (this.sh063TdkReqModel.noshiOkFlg == 0 && _this.sh063Init.housouFukaFlg == 1){
                    _this.sh063TdkReqModel.sagyoNm = housouKbnNm;
                } else {
                    _this.sh063TdkReqModel.sagyoNm = '';
                }
            }

            //console.log('_this.sh063TdkReqModel.noshiCd:'+_this.sh063TdkReqModel.noshiCd);
            //console.log('_this.sh063TdkReqModel.noshiNm:'+_this.sh063TdkReqModel.noshiNm);

            //ギフト、のし利用
            _this.sh063TdkReqModel.giftFlg = _this.sh063Init.giftFlg;
            // のしオプション使用フラグ 50506
            _this.sh063TdkReqModel.noshiUseFlg = _this.sh063Init.noshiUseFlg;

            //包装不可フラグ(包装可フラグ、包装可の商品がない場合、0になる。1:包装可 0:包装不可)
            _this.sh063TdkReqModel.housouFukaFlg = _this.sh063Init.housouFukaFlg;

            rs = confirm(_this.$i18n.t('sh063.labels.confirmMess1'));
            if(rs){
                await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH063 + _this.$UrlConstants.DO_UPDATE, _this.sh063TdkReqModel).then(function(response) {
                    if(response != null && response != undefined){
                        _this.sh063Init = response.data;
                    }
                    _this.$emit("event-loading", false);
                    //画面を閉じる
                    _this.showFlg = false;
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    if(error != null && error != undefined){
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.SH063_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                }
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
                    return false;
                });
            }else{
                return false;
            }
        },

        // 配送希望日選択時
		hopeDayRadio:function(data){
            var _this = this;
            if(data == 1){
                //指定なし
                _this.sh063TdkReqModel.hopeTdkYmd = '';
                _this.sh063TdkReqModel.hopeTdkYmdAfter = '';
            }
            _this.$forceUpdate();
        },
        handleCancel(evt){
            evt.preventDefault();
            this.$emit("data-selected", null);
            this.showFlg = false;
        } 
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.sh063TdkReqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.sh063TdkReqModel.pageSize = this.queryData.ptPageSize;
            }
        }
        //Get param from router when contructor this.  
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.sh063TdkReqModel = Object.assign({}, _this.sh063TdkReqModel, data.requestBack);
            _this.iSearch=true;
        }

    }
}
</script>